/********************************
 **** Media Gallery: Video autoplay
 *********************************/
// On variant switch, video autoplay

const MediaGalleryAutoplay = (() => {
  const initMediaGalleryAutoplay = () => {
    document.querySelectorAll(".page-product media-gallery[data-section-id]").forEach(gallery => {
      const sectionId = gallery.dataset.sectionId
      const observer = new MutationObserver(() => {
        const video = document.querySelector(
          `.page-product #MediaGallery-${sectionId} .video-item video`
        )
        if (video) {
          video.currentTime = 0
          video.play().catch(() => {})
        }
      })

      const targetGallery = document.getElementById(`MediaGallery-${sectionId}`)
      if (targetGallery) {
        observer.observe(targetGallery, { childList: true, subtree: true })
      }
    })
  }

  return { initMediaGalleryAutoplay }
})()

document.addEventListener("DOMContentLoaded", () => {
  MediaGalleryAutoplay.initMediaGalleryAutoplay()
})
